enum ColorPreset {
    PRIMARY = '$PRIMA',
    SECONDARY = '$SECON',
    TERTIARY = '$TERTI'
}

export default ColorPreset;
